<div class="modal-content m-0">
  <div class="modal-header">
    <p class="mb-0">
      {{ 'pricing.discount.list.bundles.title' | translate }}
    </p>
    <i
      class="fa-light fa-xmark ms-auto cursor-pointer"
      (click)="modalRef.close()"
    ></i>
  </div>
  <div class="modal-body">
    <app-data-table [configuration]="tableConfiguration" />
  </div>
  <div class="modal-footer">
    <button ngbAutoFocus class="btn btn-clear" (click)="modalRef.close()">
      {{ 'common.buttons.btnClose' | translate }}
    </button>
  </div>
</div>
